import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function IconBoxRender({ node }) {
  const content = node.content || {};
  const icon = content.icon || '🚀';
  const title = content.title || 'Icon Box Titel';
  const description = content.description || 'Hier kommt eine kurze Beschreibung des Features oder des USPs hin.';
  
  const iconPosition = content.iconPosition || 'top'; // top, left, right
  const iconSize = content.iconSize || '40px';
  const iconColor = content.iconColor || 'var(--tef-primary, #00A9E0)';
  
  const flexDirection = iconPosition === 'left' ? 'row' : iconPosition === 'right' ? 'row-reverse' : 'column';
  const textAlign = iconPosition === 'top' ? 'center' : 'left';
  const alignItems = iconPosition === 'top' ? 'center' : 'flex-start';

  return (
    <div style={{
      display: 'flex',
      flexDirection: flexDirection,
      alignItems: alignItems,
      textAlign: textAlign,
      gap: '16px',
      width: '100%',
      height: '100%'
    }}>
      <div style={{ 
        flexShrink: 0, 
        fontSize: iconSize, 
        color: iconColor,
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: iconSize,
        height: iconSize
      }}>
        {icon}
      </div>
      <div style={{ flex: 1 }}>
        <h4 style={{ margin: '0 0 8px 0', fontSize: '18px', fontWeight: 'bold', color: '#f8fafc' }}>{title}</h4>
        <p style={{ margin: 0, fontSize: '14px', color: '#cbd5e1', lineHeight: '1.5' }}>{description}</p>
      </div>
    </div>
  );
}

registry.register('IconBox', {
  label: 'Icon Box',
  icon: '🪧', 
  category: 'basic',
  component: IconBoxRender,
  
  defaultProps: {
    content: {
      icon: '🚀',
      title: 'Turbo-Speed',
      description: 'Höchste 5G Geschwindigkeit für alle deine Geräte, egal wo du bist.',
      iconPosition: 'left',
      iconSize: '32px',
      iconColor: '#00A9E0'
    },
    style: {
      desktop: {
        padding: '24px',
        backgroundColor: 'rgba(255,255,255,0.02)',
        borderRadius: '12px',
        border: '1px solid rgba(255,255,255,0.05)'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Inhalt',
          fields: [
            { name: 'content.icon', label: 'Icon (Emoji/Text)', type: 'text' },
            { name: 'content.title', label: 'Titel', type: 'text' },
            { name: 'content.description', label: 'Beschreibung', type: 'text' }
          ]
        },
        {
          title: 'Icon Styling',
          fields: [
            { name: 'content.iconPosition', label: 'Icon Position', type: 'select', options: ['top', 'left', 'right'] },
            { name: 'content.iconSize', label: 'Icon Größe (z.B. 40px)', type: 'text' },
            { name: 'content.iconColor', label: 'Icon Farbe', type: 'color' }
          ]
        }
      ]
    }
  ]
});
